<div id="app-assignment-list">
  <h2 class="text-2xl font-bold p-4">Assegnazioni</h2>
  <kc-data-table
    [value]="data"
    [columns]="columns"
    [showHeader]="true"
    [topbarTemplate]="onlineCounter"
    [enableSearch]="false"
    [totalRecords]="totalRecords"
    [rows]="rows"
    (onLazyLoad)="loadAssignments($event)">
  >
    <ng-template #customCaption>
      <ng-container *ngFor="let f of filters">
        <p-button
          [label]="f.label"
          size="small"
          variant="outlined"
          [severity]="selectedStatus === f.value ? f.severity : 'secondary'"
          class="me-2"
          [icon]="f.icon"
          (onClick)="applyFilter(f.value!)"
        />
      </ng-container>
    </ng-template>
  </kc-data-table>

  <ng-template #statusTemplate let-row>
    <kc-conversation-status [status]="row.status"/>
  </ng-template>

  <ng-template #mediaTemplate let-row>

    <div class="flex">
      <div class="me-3">
        <i class="fa-light fa-image-landscape me-1 text-muted opacity-50"
           [ngClass]="{ 'text-primary': row.hasMedia }">
        </i>

        @if (row.hasMedia) {
          <small class="text-primary">{{ row.mediaCount }}</small>
        } @else {
          <small class="text-muted-color">{{ row.mediaCount }}</small>
        }
      </div>


      <div>
        <i class="fa-duotone fa-light fa-folder me-1 text-muted opacity-50"
           [ngClass]="{ 'text-primary': row.hasQuote }">
        </i>

        @if (row.hasQuote) {
          <small class="text-primary">{{ row.quoteCount }}</small>
        } @else {
          <small class="text-muted-color">{{ row.quoteCount }}</small>
        }
      </div>
    </div>


  </ng-template>

  <ng-template #onlineCounter>
    <div class="flex items-center gap-2">
      <span class="filter-divider"></span>

      <p-datepicker [(ngModel)]="dateFrom" placeholder="Da Data" showIcon iconDisplay="input"
                    size="small" styleClass="filter-input" (ngModelChange)="onFilterChange()"/>

      <p-datepicker [(ngModel)]="dateTo" placeholder="A Data" showIcon iconDisplay="input"
                    size="small" styleClass="filter-input" (ngModelChange)="onFilterChange()"/>

      <span class="filter-divider"></span>

      <p-select [(ngModel)]="selectedCandidate" [options]="candidatesToAssignWithNull"
                optionLabel="email" placeholder="Operatore" size="small"
                styleClass="filter-input filter-select" (ngModelChange)="onFilterChange()"/>
    </div>
  </ng-template>

  <ng-template #avatarTemplate let-row>
    <app-conversation-initials [contact]="row.contact" [rounded]="true" [conversationAvatarId]="row.avatarId" [height]="'30px'" [width]="'30px'" [fontSize]="'12px  '"></app-conversation-initials>
  </ng-template>


  <ng-template #priorityTemplate let-row>
    <p-select
      [options]="priorities"
      [(ngModel)]="row.priority"
      optionLabel="label"
      size="small"
      optionValue="value"
      (ngModelChange)="onPriorityChange(row, row.priority)"
      [ngClass]="getPriorityClass(row.priority)"
      class="priority-select">
      <ng-template #selectedItem let-selected>
        <div class="flex items-center gap-2">
          <i [class]="selected.icon"></i>
          <span>{{ selected.label }}</span>
        </div>
      </ng-template>
      <ng-template #item let-option>
        <div class="flex items-center gap-2">
          <i [class]="option.icon"></i>
          <span>{{ option.label }}</span>
        </div>
      </ng-template>
    </p-select>
  </ng-template>

  <kc-loader [loading]="loading"></kc-loader>
</div>

